import React from 'react';

import Tag from 'antd/lib/tag';

import Admin from 'hive-admin';

import tests from '../../helpers/tests';

import Types from '../../modules/types';

import { IconDelete } from '../../components/ActionDelete';

import { createChangeLogSection } from '../../components/FieldChangeLog';

import {
  ADMIN_ALL as FILTERS_ADMIN_ALL,
  ADMIN_SELLERS as FILTERS_ADMIN_SELLERS,
} from './filters';

import {
  ADMIN_ALL as COLUMNS_ADMIN_ALL,
  ADMIN_SELLERS as COLUMNS_ADMIN_SELLERS,
} from './columns';

const {
  viewerIsAdmin,
  viewerIsNotAdmin,
  userIsNotSeller,
  userIsNotAdmin,
  viewerIsUserOwner,
  viewerIsNotUserOwner,
  viewerIsAdminAndDoesNotHavePermission,
} = tests;

const showPassword = ({ data, viewer, activity }) => (
  process.env.REACT_APP_DXTOOLS_ENV === 'development'
  || (
    activity === 'create'
  )
  || (
    /@thehive.rs$/.test(viewer?.email || '')
  )
  || (
    (data?._id || 0) === (viewer?._id || 1)
  )
);

const skipPassword = [
  'condition.not',
  showPassword,
];

const activityIsNotEdit = ({ activity }) => activity !== 'edit';

const isNotCreateActivity = ['condition.check', {
  path1: 'activity',
  op: '!==',
  value2: 'create',
}];

export default (
  Admin.compileFromLibrary(['GroupResource', {
    title: 'Users',
    // icon: 'user',
    path: '/users',
    hidden: [viewerIsNotAdmin],
    redirect: [['redirect.unauthorized']],
    archiveConfig: {
      title: 'Admins',
      label: 'Admins',
      // icon: 'user',
      createButtonPath: '/users/create',
      subtitleColumnPath: 'email',
      filters: FILTERS_ADMIN_ALL,
      columns: COLUMNS_ADMIN_ALL,
      skip: [
        viewerIsAdminAndDoesNotHavePermission('users'),
        viewerIsNotAdmin,
      ],
      hidden: [
        viewerIsAdminAndDoesNotHavePermission('users'),
        viewerIsNotAdmin,
      ],
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/store/orders',
        ],
      ],
    },
    afterArchivePages: [
      ['PageArchiveTable', {
        label: 'Sellers',
        title: 'Sellers',
        path: '/users/sellers',
        // alias: '/users',
        subtitleColumnPath: 'email',
        createButtonPath: '/users/create',
        exact: true,
        loadUrl: '/users/sellers',
        filters: FILTERS_ADMIN_SELLERS,
        columns: COLUMNS_ADMIN_SELLERS,
        loadExtractData: response => (
          response
          ? { count: response.data.count, data: response.data.data }
          : { count: 0, data: [] }
        ),
        // hidden: true,
        redirect: [
          ['redirect.unauthorized'],
          [
            'redirect.checkViewer',
            'role', '!==', 'ADMIN',
            '/store/orders',
          ],
        ],
      }],
    ],
    singleConfig: {
      hidden: true,
      alias: '/users',
      headerTitle: 'Create User',
      backButtonPaths: ['/users', '/users/sellers'],
    },
    singleEditConfig: {
      getBackButtonPaths: props => (
          props.viewer && props.viewer.role === 'ADMIN'
        ? props.backButtonPaths
        : false
      ),
      actions: [
        ['ActionSave'],
        ['ActionDelete', {
          skip: [
            viewerIsNotAdmin,
          ],
        }],
        ['ActionWithRequest', {
          name: 'activate',
          title: 'Activate',
          skip: [
            ['condition.check', { path1: 'data.active', value2: true }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/activate?id=${props.data._id}`,
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }],
        ['ActionWithRequest', {
          name: 'deactivate',
          title: 'Deactivate',
          type: 'danger',
          ghost: true,
          skip: [
            ['condition.check', { path1: 'viewer._id', path2: 'data._id' }],
            viewerIsNotAdmin,
            ['condition.check', { path1: 'data.active', value2: false }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/deactivate?id=${props.data._id}`,
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }],
        ['ActionWithRequest', {
          name: 'send-activation-email',
          title: 'Send Activation Email',
          skip: [
            ['condition.check', { path1: 'data.active', value2: true }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/activate?id=${props.data._id}&email=true`,
            method: 'POST',
          }),
        }],
        ['ActionWithRequest', {
          name: 'logout-elsewhere',
          title: 'Logout Other Devices',
          type: 'danger',
          ghost: true,
          skip: [
            viewerIsNotUserOwner,
            ['condition.check', { path1: 'data.active', value2: false }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/logout-elsewhere?id=${
              props.data._id
            }`,
            method: 'POST',
          }),
          // eslint-disable-next-line no-unused-vars
          getMessageSuccess: (data, props) => (
            data.count === 0
            ? 'Not logged in anywhere else!'
            : `Logged out of ${data.count} ${
              data.count > 1
              ? 'devices'
              : 'device'
            }!`
          ),
        }],
        ['ActionWithRequest', {
          name: 'logout-everywhere',
          title: 'Logout Everywhere',
          type: 'danger',
          ghost: true,
          skip: [
            viewerIsNotAdmin,
            viewerIsUserOwner,
            ['condition.check', { path1: 'data.active', value2: false }],
          ],
          getRequestConfig: props => ({
            url: `users/actions/logout-elsewhere?id=${
              props.data._id
            }`,
            method: 'POST',
          }),
          // eslint-disable-next-line no-unused-vars
          getMessageSuccess: (data, props) => (
            data.count === 0
            ? 'Not logged in anywhere!'
            : `Logged out of ${data.count} ${
              data.count > 1
              ? 'devices'
              : 'device'
            }!`
          ),
        }],
        ['ActionDelete', {
          name: 'closeAccount',
          title: 'Close Account',
          popconfirm: {
            title: (
              <>
                You&apos;re about to permanently delete your
                <br />
                Packman account.
                <br />
                <br />
                To confirm, please click
                the red &quot;Close Account&quot;
                <br />
                button below.
              </>
            ),
            okButtonProps: { type: 'danger', icon: 'delete' },
            okText: 'Close Account',
            cancelButtonProps: { },
            icon: <IconDelete />,
          },
          skip: [
            viewerIsAdmin,
            viewerIsNotUserOwner,
          ],
          // eslint-disable-next-line no-unused-vars
          handleSuccess: (data, props) => {
            window.location.reload();
          },
        }],
      ],
    },
    fields: [
      ['FieldText', {
        name: 'name',
        rules: [['validation.isRequired'], ['validation.isName']],
      }],
      ['FieldText', {
        name: 'email',
        autoComplete: 'new-email',
        rules: [['validation.isRequired'], ['validation.isEmail']],
      }],
      ['FieldSelect', {
        name: 'role',
        rules: [['validation.isRequired']],
        choices: Types.ROLE,
        initialValue: 'ADMIN',
        disabled: [isNotCreateActivity],
        virtual: [isNotCreateActivity],
        skip: [viewerIsNotAdmin],
      }],
      ['Divider', {
        name: 'passwordDivider',
        skip: [skipPassword],
      }],
      ['FieldText', {
        name: 'password',
        type: 'password',
        autoComplete: 'new-password',
        rules: [
          ['validation.isPassword'],
        ],
        skip: [skipPassword],
      }],
      ['FieldText', {
        name: 'confirmPassword',
        type: 'password',
        label: 'Confirm Password',
        rules: [
          ['validation.isPasswordSame'],
        ],
        skip: [skipPassword],
        virtual: true,
      }],
      // Seller store
      ['Divider', {
        name: 'sellerStoreDivider',
        skip: [
          userIsNotSeller,
          viewerIsNotAdmin,
        ],
      }],
      ['FieldConnectionSelect', {
        name: 'store',
        placeholder: 'Select the sellers store',
        url: '/stores/list',
        // getChoiceLabel: choice => choice.data.name,
        searchPaths: ['name'],
        rules: [['validation.isRequired']],
        disabled: [props => props.activity !== 'create'],
        virtual: [props => props.activity !== 'create'],
        skip: [
          userIsNotSeller,
          viewerIsNotAdmin,
        ],
      }],
      // Seller phone number and address
      ['Divider', {
        name: 'sellerInfoDivider',
        skip: [userIsNotSeller],
      }],
      ['FieldText', {
        name: 'phoneNumberString',
        label: 'Phone Number',
        rules: [['validation.isRequired']],
        skip: [userIsNotSeller],
      }],
      ['FieldRadioVertical', {
        name: 'notificationsSwitch',
        label: 'Notifications',
        rules: [['validation.isRequired']],
        initialValue: 'ENABLED',
        choices: [
          { value: 'ENABLED', label: 'All' },
          { value: 'ENABLED_EMAIL', label: 'Emails only' },
          { value: 'ENABLED_SMS', label: 'SMS only' },
          { value: 'DISABLED', label: 'None' },
        ],
        skip: [
          userIsNotSeller,
          activityIsNotEdit,
        ],
      }],
      ['FieldTitle', {
        title: 'Permissions',
        // eslint-disable-next-line max-len
        subtitle: 'Permissions deciding which groups and features are available to this user',
        skip: [
          viewerIsNotAdmin,
          userIsNotAdmin,
          activityIsNotEdit,
        ],
      }],
      ['FieldReact', {
        name: 'groups',
        label: 'Groups',
        skip: [
          viewerIsNotAdmin,
          userIsNotAdmin,
          activityIsNotEdit,
        ],
        renderContent: props => {
          const { viewer } = props;

          if (
            viewer.role !== 'ADMIN'
            || props.data?.role !== 'ADMIN'
          ) {
            return null;
          }
          const result = Types.PERMISSIONS
          .filter(key => Types.PERMISSIONS_MAP[key].type === 'GROUP')
          .reduce(
            (agr, key) => {
              if ((viewer.permissions[key]).includes(props.data?._id)) {
                agr.push(key)
              }
              return agr;
            },
            [],
          );
          return result.length > 0
          ? result.map(key => (
            <Tag key={key} style={{ marginBottom: '8px' }}>
              {
                Types
                .PERMISSIONS_MAP[key].label
              }
            </Tag>
          ))
          : (
            <Tag style={{ opacity: 0.5 }}>
              No Permissions
            </Tag>
          );
        },
      }],
      ['FieldReact', {
        name: 'features',
        label: 'Features',
        skip: [
          viewerIsNotAdmin,
          userIsNotAdmin,
          activityIsNotEdit,
        ],
        renderContent: props => {
          const { viewer } = props;

          if (
            viewer.role !== 'ADMIN'
            || props.data?.role !== 'ADMIN'
          ) {
            return null;
          }
          const result = Types.PERMISSIONS
          .filter(key => Types.PERMISSIONS_MAP[key].type === 'FEATURE')
          .reduce(
            (agr, key) => {
              if ((viewer.permissions[key]).includes(props.data?._id)) {
                agr.push(key)
              }
              return agr;
            },
            [],
          );
          return result.length > 0
          ? result.map(key => (
            <Tag key={key} style={{ marginBottom: '8px' }}>
              {
                Types
                .PERMISSIONS_MAP[key].label
              }
            </Tag>
          ))
          : (
            <Tag style={{ opacity: 0.5 }}>
              No Permissions
            </Tag>
          );
        },
      }],
      ['ActionWithFormModal', {
        name: 'permissions',
        title: 'Update Permissions',
        width: '100%',
        skip: [
          viewerIsNotAdmin,
          activityIsNotEdit,
          userIsNotAdmin,
          tests.viewerIsAdminAndDoesNotHavePermission('settings'),
        ],
        ghost: true,
        fields: [
          ['FieldRadio', {
            name: 'presets',
            label: 'Presets',
            help: 'Use to quickly set permissions for predefined teams',
            block: true,
            choices: Types.PERMISSIONS_TEAMS.map(team => ({
              value: team,
              label: Types.PERMISSIONS_TEAMS_MAP[team].label,
            })),
            prepareValueForForm: (value, props) => {
              const team = Types.PERMISSIONS_TEAMS_MAP[value];
              const keysToUpdate = Types.PERMISSIONS.reduce(
                (agr, key) => {
                  if (team.keys.includes(key)) {
                    agr[key] = true;
                  } else {
                    agr[key] = false;
                  }
                  return agr;
                },
                {},
              )
              props.form.setFieldsValue(keysToUpdate);
              return '';
            },
          }],
          ['FieldTitle', {
            title: 'Groups',
            // eslint-disable-next-line max-len
            subtitle: 'Top level permissions deciding which side menu items are available to users',
          }],
          ...Types.PERMISSIONS
          .filter(key => Types.PERMISSIONS_MAP[key].type === 'GROUP')
          .map((key) => (['FieldSwitch', {
            name: key,
            label: Types.PERMISSIONS_MAP[key].label,
            col: 8,
            getInitialValue: (_, { data, viewer }) => (
              (viewer?.permissions?.[key])?.includes(data._id)
            ),
          }])),
          ['FieldTitle', {
            title: 'Features',
            // eslint-disable-next-line max-len
            subtitle: 'Permissions deciding which features are available to users',
          }],
          ...Types.PERMISSIONS
          .filter(key => Types.PERMISSIONS_MAP[key].type === 'FEATURE')
          .map((key) => (['FieldSwitch', {
            name: key,
            label: Types.PERMISSIONS_MAP[key].label,
            col: 12,
            getInitialValue: (_, { data, viewer }) => (
              (viewer?.permissions?.[key])?.includes(data._id)
            ),
          }])),
          ['FieldTitle', {
            title: 'Note',
            size: 'small',
            // eslint-disable-next-line max-len
            subtitle: 'When changing permissions, especially removing them, it is advisable to logout the user everywhere (by calling the action in the bottom of the page). ',
          }],
        ],
        actions: [
          ['ActionWithRequest', {
            name: 'update',
            handleSuccess: () => {
              window?.location?.reload();
            },
            getRequestConfig: (props) => ({
              url: `users/${props.data._id}/update-permissions`,
              method: 'POST',
              data: props.form.getFieldsValue(),
            }),
          }],
        ],
      }],
      ...createChangeLogSection({
        changeLogConfig: {
          getWhereConditions: props => ({
            store: props.data?.store || null,
            'author.type': 'User',
            'author.subject': props.data._id,
          }),
          skipColumns: {
            author: true,
          },
        },
      }),
    ],
  }])
).pages;
